module.exports = __webpack_public_path__ + "img/Legend_of_dolly.38541159.gif";